import { Box, Paper, Typography } from '@mui/material'
import { Leaderboard, ArrowRightAltRounded } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

export default function Carnivore100Card() {
  const navigate = useNavigate()
  return (
    <Paper
      elevation={1}
      onClick={() => navigate('/carnivore-100')}
      sx={{ p: 2, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Leaderboard color="primary" />
        <Box flexGrow={1}>
          <Typography fontWeight="bold">Carnivore 100</Typography>
          <Typography variant="body2" color="text.secondary">
            The full watchlist — sortable, searchable, all timeframes.
          </Typography>
        </Box>
        <ArrowRightAltRounded />
      </Box>
    </Paper>
  )
}
